export default {
  // Buttons
  addLabel: 'Add Label',
  edit: 'Edit',
  delete: 'Delete',

  // Table columns
  englishLabel: 'English Label',
  chineseLabel: 'Chinese Label',
  createTime: 'Creation Time',
  updateTime: 'Update Time',
  operation: 'Operation',

  // Modal
  addLabelTitle: 'Add Label',
  editLabelTitle: 'Edit Label',

  // Form fields
  englishLabelField: 'English Label',
  englishLabelPlaceholder: 'Please enter English label',
  chineseLabelField: 'Chinese Label',
  chineseLabelPlaceholder: 'Please enter Chinese label',

  // Validation
  englishLabelRequired: 'Please enter English label',
  chineseLabelRequired: 'Please enter Chinese label',

  // Buttons
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Messages
  addSuccess: 'Label added successfully',
  editSuccess: 'Label updated successfully',
  deleteSuccess: 'Label deleted successfully',

  // Delete confirmation
  deleteConfirmTitle: 'Confirm Delete',
  deleteConfirmContent: 'Are you sure you want to delete "{label}"?',
  deleteConfirm: 'Delete',
}
